import { render, staticRenderFns } from "./TableListNoData.vue?vue&type=template&id=1a149693&scoped=true&"
var script = {}
import style0 from "./TableListNoData.vue?vue&type=style&index=0&id=1a149693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a149693",
  null
  
)

export default component.exports